import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords = [],
  image = "/images/default-share.jpg",
  url = "https://agoraconsulting-et.com", // Replace with your live production URL
  type = "website",
  noIndex = false,
}) => {
  const siteTitle = "Agora Consulting";
  const defaultDescription =
    "A social enterprise based in Ethiopia specializing in research, monitoring, and evaluation.";

  // Appends the master site name to your specific page title
  const fullTitle = title
    ? `${title} | ${siteTitle}`
    : `${siteTitle} — Crafting Pathways to Prosperity`;
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

  return (
    <Helmet>
      {/* Search Engine Essentials */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(", ")} />
      )}
      <meta
        name="robots"
        content={noIndex ? "noindex, nofollow" : "index, follow"}
      />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook (For Social Media Previews) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title ? fullTitle : siteTitle} />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <meta property="og:image" content={`${backendUrl}${image}`} />
      <meta property="og:url" content={url} />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title ? fullTitle : siteTitle} />
      <meta
        name="twitter:description"
        content={description || defaultDescription}
      />
      <meta name="twitter:image" content={`${backendUrl}${image}`} />
    </Helmet>
  );
};

export default SEO;
